module.exports = __webpack_public_path__ + "img/bg1.f234c450.png";